import React, { createContext, useState, useContext } from 'react';

import { WebAuth } from 'auth0-js';
import env from '../constants';
import history from '../history';

const generateAuth = () => new WebAuth({
  clientID: env.clientId,
  domain: env.domain,
  redirectUri: env.callbackUrl,
  audience: env.audience,
  responseType: 'token id_token',
  scope: 'openid profile email',
});

export const Auth0Context = createContext(null);

const useAuthState = () => useState({
  authenticated: false,
  accessToken: '',
  idToken: '',
  name: '',
  profilePicture: '',
  countrySelected: 'co',
  language: '',
  email: '',
  allowedRoutes: [],
  expiresAt: 0,
});

const check = (rules, action, alterUrl) => {
  const url = alterUrl ? `/dashboard${alterUrl}` : history.location.pathname;
  const filteredRules = rules.filter(value => `/dashboard${value.url}` === url);
  if (!filteredRules.length) {
    return false;
  }
  const [{ permissions }] = filteredRules;


  return permissions && permissions.includes(action);
};

const useContextValue = () => {
  const [authState, updateAuthState] = useAuthState();
  return {
    auth0: generateAuth(),
    authState,
    updateAuthState,
    check,
  };
};
export const Auth0Provider = ({ children }) => {
  const value = useContextValue();
  return (
    <Auth0Context.Provider value={value}>{children}</Auth0Context.Provider>
  );
};

export const useAuth0Context = () => useContext(Auth0Context);
